// export const BASE_URL = 'http://localhost:5000'
export const BASE_URL = 'https://pressboxpools.com/api'

export const ihdbBaseURL =
  'http://www.hockeydb.com/ihdb/stats/pdisplay.php?pid='
